export const CheckIcon = (props) => {
  const size = props.size ?? "30"

  return (
    // <svg viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path d="M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM12 22.5L4.5 15L6.615 12.885L12 18.255L23.385 6.87L25.5 9L12 22.5Z"  />
    // </svg>

    // <svg  viewBox="0 -960 960 960" ><path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"/></svg>
    // <svg   viewBox="0 -960 960 960" ><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>
    <svg width={size} height={size} fill={props.fill ?? 'currentColor'} viewBox="0 -960 960 960" ><path d="M382-200 113-469l97-97 172 173 369-369 97 96-466 466Z"/></svg>
  )
}